import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import cx from 'classnames';

import { casualName } from 'utils';
import Avatar from 'common/avatar';
import FundraiserSelect from './fundraiser-select';

export default class Fundraiser extends Component {
    static propTypes = {
        onSelect: PropTypes.func.isRequired,
        fundraisers: PropTypes.arrayOf(
            PropTypes.shape({
                user: PropTypes.shape({
                    firstName: PropTypes.string,
                    lastName: PropTypes.string,
                    avatar: PropTypes.shape({
                        id: PropTypes.string,
                    }),
                }),
            })
        ).isRequired,
        isLocked: PropTypes.bool,
        fundraiser: PropTypes.shape({
            user: PropTypes.shape({
                firstName: PropTypes.string,
                lastName: PropTypes.string,
                avatar: PropTypes.shape({
                    id: PropTypes.string,
                }),
            }),
        }),
    };

    static defaultProps = {
        isLocked: false,
        fundraiser: null,
    };

    state = {
        isSelecting: false,
    };

    handleChooseClick = () => this.setState({ isSelecting: true });

    handleModalClose = () => this.setState({ isSelecting: false });

    handleFundraiserSelect = fundraiser => {
        const { onSelect } = this.props;
        onSelect(fundraiser);
        this.handleModalClose();
    };

    render() {
        const { fundraiser, fundraisers, isLocked } = this.props;
        const { isSelecting } = this.state;

        const hasImage = get(fundraiser, 'user.avatar.id');

        return (
            <div
                className="font-medium text-14 text-gray-70 mt-4 md:flex justify-center items-center sm:block"
                data-testid="fundraiser-select"
            >
                <p className="sm:mb-2 md:inline-block">Give credit to:</p>
                <button
                    type="button"
                    className={cx('inline-block whitespace-nowrap md:ml-2', {
                        'link-green': !isLocked,
                        'text-gray-70 pointer-events-none': isLocked,
                    })}
                    onClick={this.handleChooseClick}
                    data-testid="fundraiser-toggle"
                >
                    {fundraiser ? (
                        <div className="inline-flex items-center" data-testid="fundraiser-selected">
                            {hasImage && (
                                <Avatar
                                    imageId={hasImage}
                                    firstName={fundraiser.user.firstName}
                                    lastName={fundraiser.user.lastName}
                                    className="mr-2 w-12 h-12 rounded-full"
                                />
                            )}
                            <span>
                                {casualName(fundraiser.user.firstName, fundraiser.user.lastName)}
                            </span>
                        </div>
                    ) : (
                        'Choose fundraiser'
                    )}
                </button>

                <FundraiserSelect
                    options={fundraisers}
                    show={isSelecting}
                    onClose={this.handleModalClose}
                    onSelect={this.handleFundraiserSelect}
                />
            </div>
        );
    }
}
